module.exports = __webpack_public_path__ + "img/Norway.159b14cd.svg";